import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* billingAddCreditsPreview({ payload: { amount, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.billing.credits.add_preview,
      params: {
        amount_cents: Number.parseFloat(amount) * 100
      }
    });

    onSuccess && onSuccess(data.result);
    yield put(actions.billingAddCreditsPreviewDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.billingAddCreditsPreviewFailed,
      handledErrors,
      endpoint: api.billing.credits.add_preview.url
    });
  }
}

export const billingAddCreditsPreviewSaga = takeEvery(types.BILLING_ADD_CREDITS_PREVIEW_REQUEST, billingAddCreditsPreview);